<template>
  <div class="marquee-container">
    <div class="marquee-wrapper">
      <div class="marquee">
        <div class="marquee-group" :style="{ '--duration': `${duration}s` }">
          <div v-for="(image, index) in images" 
               :key="`img-${index}`" 
               class="marquee-item">
            <img :src="image" 
                 :alt="'Partner logo ' + (index + 1)"
                 class="marquee-img">
          </div>
        </div>
        <div class="marquee-group" :style="{ '--duration': `${duration}s` }" aria-hidden="true">
          <div v-for="(image, index) in images" 
               :key="`img-clone-${index}`" 
               class="marquee-item">
            <img :src="image" 
                 :alt="'Partner logo ' + (index + 1)"
                 class="marquee-img">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarqueeSlider',
  props: {
    images: {
      type: Array,
      required: true
    },
    duration: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style lang="stylus" scoped>
.marquee-container
  width: 100%
  overflow: hidden
  background: white
  padding: 2rem 0

.marquee-wrapper
  position: relative
  width: 100%

.marquee
  display: flex
  position: relative
  width: max-content

.marquee-group
  display: flex
  animation: scroll var(--duration) linear infinite
  gap: 2rem
  padding-right: 2rem

.marquee-item
  flex: 0 0 auto
  display: flex
  align-items: flex-end
  justify-content: center

.marquee-img
  width: 340px
  height: auto
  object-fit: contain
  display: block

@keyframes scroll
  0%
    transform: translateX(0)
  100%
    transform: translateX(-100%)

// Optional: Pause on hover


@media (max-width: 500px)
  .marquee-img
    width: 180px
</style> 